import { useEffect, useState } from 'react'
import { LUX_PLUS_TOURS_CAMPAIGN } from 'luxPlus/constants/base'
import { dateIsAfterOrSame, dateIsBefore } from 'lib/datetime/dateUtils'

function getIsLuxPlusToursCampaignActive() {
  const now = new Date()

  return (
    dateIsAfterOrSame(now, LUX_PLUS_TOURS_CAMPAIGN.START_DATE) &&
    dateIsBefore(now, LUX_PLUS_TOURS_CAMPAIGN.END_DATE)
  )
}

function useIsLuxPlusToursCampaignActive() {
  const [isCampaignActive, setIsCampaignActive] = useState(getIsLuxPlusToursCampaignActive)

  useEffect(() => {
    const now = new Date()

    if (dateIsBefore(now, LUX_PLUS_TOURS_CAMPAIGN.START_DATE)) {
      const startTimeout = window.setTimeout(() => {
        setIsCampaignActive(getIsLuxPlusToursCampaignActive())
      }, LUX_PLUS_TOURS_CAMPAIGN.START_DATE.getTime() - now.getTime())

      return () => window.clearTimeout(startTimeout)
    }

    if (isCampaignActive) {
      const endTimeout = window.setTimeout(() => {
        setIsCampaignActive(false)
      }, LUX_PLUS_TOURS_CAMPAIGN.END_DATE.getTime() - now.getTime())

      return () => window.clearTimeout(endTimeout)
    }
  }, [isCampaignActive])

  return isCampaignActive
}

export default useIsLuxPlusToursCampaignActive
